import React from "react";
import { assetStatuses } from "_constants";
import PropTypes from "prop-types";
import Private from "rialto-icons/Lock";
import FullyLet from "rialto-icons/NotUnderOffer";
import Invite from "rialto-icons/ShareStatusAll";
import Public from "rialto-icons/ShareStatusPublic";

import Dropdown, { DropdownButton } from "components/Dropdown";
import Translate from "utils/translate";

const { t } = new Translate("ShareStatusSelector");

const icons = (status) => {
  const statuses = {
    private: () => Private,
    public: () => Public,
    invite: () => Invite,
    fully_let: () => FullyLet,
    default: () => Invite,
  };

  return (statuses[status] || statuses.default)();
};

const AssetStatusField = ({ field: { name, value }, form: { setFieldValue } }) => {
  const items = assetStatuses.filter((item) => item !== "sold" && item !== "other");

  return (
    <Dropdown
      align="left"
      header={t("header")}
      inputComponent={DropdownButton}
      inputComponentProps={{
        icon: icons(value),
        label: t(`asset.statuses.${value}`),
        isLarge: true,
      }}
      isFullWidth={false}
      onChange={(v) => setFieldValue(name, v)}
      selectedValues={[value]}
      valueExtractor={(status) => ({
        icon: icons(status),
        label: t(`asset.statuses.${status}`),
      })}
      values={items}
    />
  );
};

AssetStatusField.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
};

export default AssetStatusField;
